module.exports = __webpack_public_path__ + "img/account_buy_crypto.9bcbcf35.svg";